var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable import/no-named-as-default */
import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Outlet, useLocation, useParams } from 'react-router';
import { useAtom } from 'jotai';
import Notifications from "../Notifications";
import Cookiepopup from "./Cookiepopup";
import { Icon } from "../UI";
import { socket } from "../socket";
import { NotificationsContainer } from "../V2/Components/UI";
import { Matomo, CleanInsights } from "../V2/Components/Analitycs";
import { settingsAtom } from "../V2/atoms/settingsAtom";
import { TranslateModal, t } from "../I18N";
import { inlineEditAtom } from "../V2/atoms";
import Confirm from "./Confirm";
import { Menu } from "./Menu";
import { AppMainContext } from "./AppMainContext";
import SiteName from "./SiteName";
import GoogleAnalytics from "./GoogleAnalytics";
import 'react-widgets/dist/css/react-widgets.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'nprogress/nprogress.css';
import 'flag-icons/sass/flag-icons.scss';
import "./scss/styles.scss";
import "./styles/globals.css";
import 'flowbite';

const App = ({ customParams }) => {var _settings$languages;
  const [showMenu, setShowMenu] = useState(false);
  const [inlineEditState] = useAtom(inlineEditAtom);
  const [confirmOptions, setConfirmOptions] = useState({});
  const [settings, setSettings] = useAtom(settingsAtom);

  const location = useLocation();
  const params = useParams();
  const sharedId = params.sharedId || (customParams === null || customParams === void 0 ? void 0 : customParams.sharedId);

  const possibleLanguages = ((_settings$languages = settings.languages) === null || _settings$languages === void 0 ? void 0 : _settings$languages.map((l) => l.key)) || [];
  const shouldAddAppClassName =
  ['/', ...possibleLanguages.map((lang) => `/${lang}/`)].includes(location.pathname) ||
  location.pathname.match(/\/page\/.*\/.*/g) ||
  location.pathname.match(/\/entity\/.*/g);

  const toggleMobileMenu = (visible) => {
    setShowMenu(visible);
  };

  const confirm = (options) => {
    setConfirmOptions(options);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const appContext = useMemo(() => ({ confirm }));

  let MenuButtonIcon = 'bars';
  let navClass = 'menuNav';

  if (showMenu) {
    MenuButtonIcon = 'times';
    navClass += ' is-active';
  }

  const appClassName = shouldAddAppClassName && sharedId ? `pageId_${sharedId}` : '';

  socket.on('updateSettings', (_settings) => {
    setSettings(_settings);
  });

  return (/*#__PURE__*/
    _jsx("div", { id: "app", className: appClassName }, void 0, /*#__PURE__*/
    _jsx(Notifications, {}), /*#__PURE__*/
    _jsx(Cookiepopup, {}), /*#__PURE__*/
    _jsx("div", { className: "content" }, void 0, /*#__PURE__*/
    _jsx("nav", { className: "library-nav" }, void 0, /*#__PURE__*/
    _jsx("h1", {}, void 0, /*#__PURE__*/
    _jsx(SiteName, {})
    )
    ), /*#__PURE__*/
    _jsx("header", {}, void 0, /*#__PURE__*/
    _jsx("button", {
      className: "menu-button",
      onClick: () => toggleMobileMenu(MenuButtonIcon === 'bars'),
      type: "button",
      "aria-label": t('System', 'Menu', null, false) }, void 0, /*#__PURE__*/

    _jsx(Icon, { icon: MenuButtonIcon })
    ), /*#__PURE__*/
    _jsx("h1", { className: "logotype" }, void 0, /*#__PURE__*/
    _jsx(SiteName, {})
    ), /*#__PURE__*/
    _jsx(Menu, { location: location, toggleMobileMenu: toggleMobileMenu, className: navClass }), /*#__PURE__*/
    _jsx("div", { className: "nprogress-container" })
    ), /*#__PURE__*/
    _jsx("main", { className: "app-content container-fluid" }, void 0, /*#__PURE__*/
    _jsx(AppMainContext.Provider, { value: appContext }, void 0, /*#__PURE__*/
    React.createElement(Confirm, confirmOptions), /*#__PURE__*/
    _jsx(Outlet, {}), /*#__PURE__*/
    _jsx(GoogleAnalytics, {}), /*#__PURE__*/
    _jsx(Matomo, {}), /*#__PURE__*/
    _jsx(CleanInsights, {})
    )
    )
    ), /*#__PURE__*/
    _jsx(NotificationsContainer, {}),
    inlineEditState.inlineEdit && inlineEditState.context && /*#__PURE__*/_jsx(TranslateModal, {})
    ));

};







export { App };